export enum ROLES {
  MERCHANT = 'Merchant',
  ADMIN = 'Admin',
  SUPER_ADMIN = 'SuperAdmin',
  USER = 'User',
  SALES_AGENT = 'SalesAgent',
}

export const ROLE_VALUES = Object.values(ROLES);
